import { booleanAttribute, computed, Directive, input } from '@angular/core';

@Directive({
  selector: '[rmaLoadingIndicator]',
  host: {
    // The class is defined in the global stylesheet.
    '[class.rma-loading-indicator]': 'rmaLoadingIndicator()',
    // The attribute rather than the property: this selector carries no tag restriction, so
    // Angular type-checks a host property binding against a synthetic element that has no
    // `disabled` (NG8002). On a `<button>` — where all but one live usage sits — the attribute
    // reflects to the property, so the host disables exactly as it did before.
    '[attr.disabled]': 'isDisabled() ? "" : null',
  },
})
export class LoadingIndicatorDirective {
  // Coerced for the same reason as `disabled` below: without it the attribute form
  // `rmaLoadingIndicator="false"` arrives as the string `"false"`, which is truthy, and would
  // hold the host in a loading state that never clears. The coercion also folds `null` — what an
  // `async` pipe emits before its source has produced — to `false`, so the two agree.
  public readonly rmaLoadingIndicator = input(false, { transform: booleanAttribute });

  // Coerced, so a bare `disabled` attribute arrives as `true` rather than as the empty string —
  // which is falsy, and would make the computed below report the host enabled and strip the
  // author's own attribute back off it. `disabled="false"` correspondingly means not disabled.
  // `rmaButton` coerces its own `disabled` input identically and depends on the two agreeing:
  // see `applyNativeDisabled` in @rma/generic/ui/button.
  public readonly disabled = input(false, { transform: booleanAttribute });

  public readonly isDisabled = computed(() => this.disabled() || this.rmaLoadingIndicator());
}
